// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ParticipantActionsLog_wrapper__yPbNx"};